import SeoJsonLd from '@/components/base/SeoJsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'ALAFIJAYA Bogotá',
  description:
    'Servicios automotrices verificados en Bogotá D.C. Revisión tecnomecánica, SOAT, preventivas gratuitas y trámites vehiculares.',
  url: siteUrl,
  telephone: '+573102737047',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Bogotá',
    addressRegion: 'Bogotá D.C.',
    addressCountry: 'CO',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: '4.6097',
    longitude: '-74.0817',
  },
  areaServed: {
    '@type': 'City',
    name: 'Bogotá D.C.',
  },
  priceRange: '$$',
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '07:00',
      closes: '18:00',
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: 'Saturday',
      opens: '08:00',
      closes: '14:00',
    },
  ],
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '¿Qué servicios ofrece ALAFIJAYA en Bogotá?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'En Bogotá conectamos tu vehículo con proveedores verificados para revisión tecnomecánica, SOAT, preventivas gratuitas, trámites vehiculares y peritajes técnicos.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Los proveedores de ALAFIJAYA en Bogotá están verificados?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Sí, todos nuestros proveedores en Bogotá están verificados legalmente. Trabajamos solo con aliados confiables.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Cómo contacto a ALAFIJAYA en Bogotá?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Escríbenos por WhatsApp al +57 310 273 7047. Atención inmediata de lunes a sábado.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Qué es la revisión tecnomecánica RTM?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'La revisión tecnomecánica (RTM) es una inspección obligatoria en Colombia que verifica que tu vehículo cumple con los estándares de seguridad vial y emisiones. ALAFIJAYA te conecta con CDAs verificados en Bogotá para realizarla.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Cuánto cuesta la revisión tecnomecánica en Bogotá?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Con ALAFIJAYA puedes asegurar tu RTM desde $318.000 y acceder a beneficios promocionales como el seguro técnico de seguridad ($50.000 redimibles) y bonos de llantas de hasta $200.000.',
      },
    },
  ],
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'ALAFIJAYA Bogotá - Revisión Tecnomecánica, SOAT y Servicios Automotrices Verificados',
  description:
    'Conectamos tu vehículo con proveedores verificados en Bogotá: revisión tecnomecánica, SOAT, preventivas gratuitas y trámites vehiculares.',
  url: siteUrl,
  inLanguage: 'es-CO',
  isPartOf: {
    '@type': 'WebSite',
    name: 'ALAFIJAYA',
    url: siteUrl,
  },
};

export default function HomeSeo() {
  return <SeoJsonLd schemas={[localBusinessSchema, faqSchema, webPageSchema]} />;
}
